import YoYChart from './YoYChart';
export default YoYChart;
